export type ManagerContractRowForFilter = {
  status?: string | null;
  propertyName?: string | null;
  planName?: string | null;
};

/** When hideDraftContracts is on, keeps only signed rows (hides draft/sent/pending/cancelled). */
export const filterManagerContractRows = <T extends ManagerContractRowForFilter>(
  rows: T[],
  hideDraftContracts: boolean,
): T[] => {
  if (!hideDraftContracts) return rows;
  return rows.filter((row) => String(row.status || "").toLowerCase() === "signed");
};
